// Which Amplemarket mailbox a new sequence sends from (Phase 4, item 7). Defaults to the
// strategist's own; a dropdown only when Amplemarket lists more than one usable mailbox.
import type { SequenceMailboxes } from '../api/types';
import { usableMailboxes } from '../lib/sequenceBuilder';

export function SequenceMailboxPicker({ mailboxes, loading, value, disabled, onChange }: {
  mailboxes: SequenceMailboxes | null;
  loading: boolean;
  value: string;
  disabled: boolean;
  onChange: (email: string) => void;
}) {
  if (loading) return <p className="seqhint">Reading your mailboxes…</p>;
  if (!mailboxes) return null;
  if (mailboxes.refusal) return <p className="seqhint seqfailure">{mailboxes.refusal}</p>;

  // Not listed by Amplemarket: the sequence sends from your own mailbox, and Amplemarket checks it.
  const options = usableMailboxes(mailboxes);
  if (!mailboxes.readable || options.length === 0) {
    return <p className="seqhint">Sends from your own mailbox.</p>;
  }
  if (options.length === 1) return <p className="seqhint">Sends from {options[0]}</p>;
  return (
    <div className="seqrow">
      <label htmlFor="seq-mailbox" className="seqhint">Sends from</label>
      <select id="seq-mailbox" value={value} disabled={disabled} onChange={event => onChange(event.target.value)}>
        {options.map(email => <option key={email} value={email}>{email}</option>)}
      </select>
    </div>
  );
}
